import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import _get from 'lodash-es/get';
import Button from 'sushiweb/Button/Button';
import Modal from 'sushiweb/Modal/Modal';
import MenuItem from 'sushiweb/MenuItem/MenuItem';
import Dropdown from 'sushiweb/Dropdown/Dropdown';
import Layout from 'sushiweb/Layout/Layout';
import Input from 'sushiweb/InputTypes/Input/Input';
import CheckCircleFill from 'sushiweb/Icons/all/CheckCircleFill';
import H4 from 'sushiweb/Typography/Heading/H4';
import Spinner from 'sushiweb/Spinner/Spinner';
import red from 'sushiweb/tokens/color/red';
import green from 'sushiweb/tokens/color/green';
import yellow from 'sushiweb/tokens/color/yellow';
import grey from 'sushiweb/tokens/color/grey';
import Check from 'sushiweb/Icons/all/Check';
import white from 'sushiweb/tokens/color/white';
import { P } from 'sushiweb/Typography/Text';
import {
  reportStatusEnum,
  reportTypeEnum,
} from '../../common/components/constants';
import {
  AlignItemsWrapper,
  ContentsWrapper,
  CreateButtonWrapper,
  DownloadButtonWrapper,
  DropdownWrapper,
  JustifyContentWrapper,
  PollingModalsSpinnerHolder,
  PollingStateWrapper,
  ReponseHeader,
  ReportFormWrapper,
  ReportModalBtnStyle,
  ReportResponseStateWrapper,
  SelectItemsContainer,
  SpinnerWrapper,
  SubmitBtnWrapper,
  CheckboxWrapper,
  CheckedBox,
  CustomDropdown,
  DropdownOptions,
  StyledChevronDown,
  StyledChevronUp,
  UncheckedBox,
  DropdownHeaderWrapper,
  ReportModalBtnStyleRed,
  ReportModalFooter,
} from './styles';
import { SingleLineArrow } from '../../../components/SVGs/commonSVGs';
import useReportsPolling from '../../common/utils/useReportsPolling';
import { GET_REPORT_DETAILS } from '../../../constants/urls';
import { formatDateInYYYYMMDD } from '../../../helpers';

const CreateReportModal = ({
  title,
  showModal,
  closeModal,
  reportID,
  groupsData,
  selectedWorkspace,
  generateReport,
  initiatingReport,
  initiatedReport,
  iscurrentMonthConsumption,
  isBulkOrderInvoicesEnabled,
  mappedOffices,
  invoiceData,
  invoiceStartDate,
}) => {
  const reportTypeList = [
    {
      key: reportTypeEnum.REPORT_TYPE_COMPANY_CONSUMPTION,
      value: 'Consumption history | Company level',
    },
    {
      key: reportTypeEnum.REPORT_TYPE_GROUP_CONSUMPTION,
      value: 'Consumption history | Team level',
    },
    {
      key: reportTypeEnum.REPORT_TYPE_CURRENT_MONTH_CONSUMPTION,
      value: 'Current month consumption statement',
    },
  ];
  if (mappedOffices && mappedOffices.length > 1) {
    reportTypeList.push({
      key: reportTypeEnum.REPORT_TYPE_GST_BASED_CONSUMPTION,
      value: 'Invoice Report | GST level',
    });
  }
  if (isBulkOrderInvoicesEnabled) {
    reportTypeList.push({
      key: reportTypeEnum.REPORT_TYPE_COMPANY_ORDER_INVOICE,
      value: 'Order invoices | Company level',
    });
  }
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const lastMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);

  const orderInvoicesMonths = [];
  // Generate the last 6 months dynamically
  for (let i = 0; i < 6; i += 1) {
    const monthDate = new Date(today.getFullYear(), today.getMonth() - i, 1);
    orderInvoicesMonths.push({
      key: monthDate,
      value: monthDate
        .toLocaleString('default', { month: 'short', year: 'numeric' })
        .replace(' ', ', '),
    });
  }

  const gstInvoiceMonths = getGstOrderInvoiceMonths(invoiceData);
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);
  const [startDate, setStartDate] = useState(
    invoiceStartDate !== ''
      ? invoiceStartDate
      : firstDayOfMonth.toISOString().split('T')[0],
  );
  const [endDate, setEndDate] = useState(yesterday.toISOString().split('T')[0]);
  const [pollingStarted, setPollingStarted] = useState(false);
  const [initiateGeneration, setInitiateGeneration] = useState(false);
  const [pollingCounter, setPollingCounter] = useState(0);
  const [pollingFrequency, setPollingFrequency] = useState(2);
  const [reportState, setReportState] = useState(
    reportStatusEnum.REPORT_STATUS_UNSPECIFIED,
  );
  const [filePath, setFilePath] = useState('');
  const terminalStates = [
    reportStatusEnum.REPORT_STATUS_GENERATED,
    reportStatusEnum.REPORT_STATUS_FAILED,
    reportStatusEnum.REPORT_STATUS_SYSTEM_FAILED,
  ];
  const [selectedReportType, setSelectedReportType] = useState(
    iscurrentMonthConsumption ? reportTypeList[2] : reportTypeList[0],
  );
  const [selectedOrderInvoiceMonth, setSelectedOrderInvoiceMonth] = useState(
    orderInvoicesMonths[0],
  );
  const [
    selectedGstOrderInvoiceMonth,
    setSelectedGstOrderInvoiceMonth,
  ] = useState(gstInvoiceMonths[0] || []);
  const [continueDisabled, setContinueDisabled] = useState(true);
  const [openSelectItems, setOpenSelectItems] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedOffices, setSelectedOffices] = useState([]);
  const [isReportInitiated, setIsReportInitiated] = useState(false);

  function getGstOrderInvoiceMonths(invoicesList) {
    if (!Array.isArray(invoicesList) || invoicesList.length === 0)
      return [
        {
          key: today,
          value: today
            .toLocaleString('default', { month: 'short', year: 'numeric' })
            .replace(' ', ', '),
        },
      ];
    return invoicesList
      .sort((a, b) => new Date(b.end_date) - new Date(a.end_date)) // Sort in descending order by end_date
      .slice(0, 5) // Take the last 5 invoices month, to update later (Added this as limitgroupid was added to ordermodel 5months ago at the time of writing this code)
      .map(invoice => {
        const invoiceDate = new Date(invoice.end_date);
        return {
          key: invoiceDate,
          value: invoiceDate
            .toLocaleString('default', { month: 'short', year: 'numeric' })
            .replace(' ', ', '),
        };
      });
  }

  const handleOpenSelectItemsClose = () => {
    setOpenSelectItems(false);
  };
  const { groups = [] } = groupsData;

  const handleReportTypeSelect = value => {
    setSelectedReportType(value);
  };
  const handleOrderInvoiceMonthSelect = value => {
    setSelectedOrderInvoiceMonth(value);
  };
  const handleGstOrderInvoiceMonthSelect = value => {
    setSelectedGstOrderInvoiceMonth(value);
  };
  const handleStartDateChange = val => {
    setStartDate(val);
  };
  const handleEndDateChange = val => {
    setEndDate(val);
  };
  const reportTypeMenuItems = () => {
    if (iscurrentMonthConsumption) {
      return reportTypeList
        .filter(
          item =>
            item.key === reportTypeEnum.REPORT_TYPE_CURRENT_MONTH_CONSUMPTION,
        )
        .map(item => {
          return <MenuItem value={item} label={item.value} />;
        });
    }
    return reportTypeList.map(item => {
      return <MenuItem value={item} label={item.value} />;
    });
  };
  const orderInvoiceMonthsMenuItems = () => {
    return orderInvoicesMonths.map(item => {
      return <MenuItem value={item} label={item.value} />;
    });
  };

  const gstOrderInvoiceMonthsMenuItems = () => {
    return getGstOrderInvoiceMonths(invoiceData).map(item => {
      return <MenuItem value={item} label={item.value} />;
    });
  };
  const selectDateRange = () => {
    if (
      selectedReportType.key ===
      reportTypeEnum.REPORT_TYPE_COMPANY_ORDER_INVOICE
    ) {
      return (
        <Layout.Item colD={12} colT={12} colM={12}>
          <DropdownWrapper>
            <Dropdown
              value={selectedOrderInvoiceMonth.value}
              onSelect={handleOrderInvoiceMonthSelect}
              width='460px'
            >
              {orderInvoiceMonthsMenuItems()}
            </Dropdown>
          </DropdownWrapper>
        </Layout.Item>
      );
    }
    if (
      selectedReportType.key ===
      reportTypeEnum.REPORT_TYPE_GST_BASED_CONSUMPTION
    ) {
      return (
        <Layout.Item
          colD={12}
          colT={12}
          colM={12}
          style={{ marginBottom: '20px' }}
        >
          <DropdownWrapper>
            <Dropdown
              value={selectedGstOrderInvoiceMonth.value}
              onSelect={handleGstOrderInvoiceMonthSelect}
              width='460px'
            >
              {gstOrderInvoiceMonthsMenuItems()}
            </Dropdown>
          </DropdownWrapper>
        </Layout.Item>
      );
    }
    return (
      <Layout>
        <Layout.Item colD={6} colT={6} colM={6}>
          <Input
            label='Start date'
            innerWidth='100%'
            type='date'
            value={startDate}
            onChange={handleStartDateChange}
            disabled={
              selectedReportType.key ===
              reportTypeEnum.REPORT_TYPE_CURRENT_MONTH_CONSUMPTION
            }
          />
        </Layout.Item>
        <Layout.Item colD={6} colT={6} colM={6}>
          <Input
            label='End date'
            innerWidth='100%'
            type='date'
            value={endDate}
            onChange={handleEndDateChange}
          />
        </Layout.Item>
      </Layout>
    );
  };

  const getMonthDateRange = selectedDate => {
    const firstDay = new Date(selectedDate);
    firstDay.setDate(1);

    const isCurrentMonth =
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear();

    const lastDay = isCurrentMonth
      ? yesterday
      : new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0);

    const monthStartDate = formatDateInYYYYMMDD(firstDay);
    const monthEndDate = formatDateInYYYYMMDD(lastDay);

    return { monthStartDate, monthEndDate };
  };

  const handleGenerateReport = () => {
    const reportBody = {
      workspace_id: selectedWorkspace.workspace_id,
      start_date: startDate,
      end_date: endDate,
      report_type: selectedReportType?.key ?? 1,
    };
    if (
      selectedReportType.key === reportTypeEnum.REPORT_TYPE_GROUP_CONSUMPTION
    ) {
      const groupIDs = selectedGroups.map(group => group.group_id);
      reportBody.report_type_info = {
        group_ids: groupIDs,
      };
    }
    if (
      selectedReportType.key ===
      reportTypeEnum.REPORT_TYPE_GST_BASED_CONSUMPTION
    ) {
      const officeIDs = selectedOffices.map(office => office.office_id);
      const selectedDate = selectedGstOrderInvoiceMonth.key;
      const { monthStartDate, monthEndDate } = getMonthDateRange(selectedDate);
      reportBody.start_date = monthStartDate;
      reportBody.end_date = monthEndDate;

      reportBody.report_type_info = {
        office_ids: officeIDs,
      };
    }

    if (
      selectedReportType.key ===
      reportTypeEnum.REPORT_TYPE_COMPANY_ORDER_INVOICE
    ) {
      const monthDate = selectedOrderInvoiceMonth.key ?? lastMonthDate;
      const [monthStartDate] = new Date(
        monthDate.getFullYear(),
        monthDate.getMonth(),
        2,
      )
        .toISOString()
        .split('T');
      const [monthEndDate] = new Date(
        monthDate.getFullYear(),
        monthDate.getMonth() + 1,
        1,
      )
        .toISOString()
        .split('T');

      reportBody.start_date = monthStartDate;
      reportBody.end_date = monthEndDate;
    }
    generateReport({ reportBody });
  };

  const onResponse = ({ isError, response }) => {
    const pollingCount = pollingCounter + 1;
    setPollingCounter(pollingCount);
    const respStatus = _get(response, 'status', false);
    const status = _get(response, 'data.status', 0);
    const fPath = _get(response, 'data.file_path', '');
    setFilePath(fPath);
    if (pollingCount === 5) {
      setPollingStarted(false);
      setReportState(reportStatusEnum.REPORT_STATUS_DELAYED);
      return;
    }
    if (isError) {
      setReportState(reportStatusEnum.REPORT_STATUS_FAILED);
      setPollingStarted(false);
      return;
    }
    if (!respStatus) {
      setReportState(reportStatusEnum.REPORT_STATUS_FAILED);
      setPollingStarted(false);
    }
    if (terminalStates.includes(status)) {
      setReportState(status);
      setPollingStarted(false);
    } else {
      setPollingFrequency(3);
    }
  };

  useReportsPolling({
    reportID,
    frequency: pollingFrequency,
    isPollingStarted: pollingStarted,
    onResponse,
    url: GET_REPORT_DETAILS,
  });

  useEffect(() => {
    if (selectedReportType.key !== reportTypeEnum.REPORT_TYPE_UNSPECIFIED) {
      // date check
      setContinueDisabled(false);
    }
    if (
      selectedReportType.key === reportTypeEnum.REPORT_TYPE_GROUP_CONSUMPTION
    ) {
      if (selectedGroups.length === 0) {
        setContinueDisabled(true);
      }
    }
    if (
      selectedReportType.key ===
      reportTypeEnum.REPORT_TYPE_GST_BASED_CONSUMPTION
    ) {
      if (selectedOffices.length === 0) {
        setContinueDisabled(true);
      }
    }
  }, [selectedReportType, selectedGroups, selectedOffices]);

  useEffect(() => {
    if (initiatingReport) setIsReportInitiated(true);
    if (!initiatingReport && initiatedReport && reportID !== '') {
      setPollingStarted(true);
      setInitiateGeneration(true);
    }
  }, [initiatingReport, initiatedReport]);

  const selectGroup = group => {
    if (selectedGroups.includes(group)) {
      setSelectedGroups(
        selectedGroups.filter(selectedGroup => selectedGroup !== group),
      );
    } else {
      setSelectedGroups([...selectedGroups, group]);
    }
  };

  const selectOffice = office => {
    if (selectedOffices.includes(office)) {
      setSelectedOffices(
        selectedOffices.filter(seleectedOffice => seleectedOffice !== office),
      );
    } else {
      setSelectedOffices([...selectedOffices, office]);
    }
  };

  const groupsSelectItems = () => {
    return (
      <SelectItemsContainer handleClickOutside={handleOpenSelectItemsClose}>
        <CustomDropdown
          open={openSelectItems}
          style={{ pointerEvents: 'all' }}
          dark
        >
          <DropdownHeaderWrapper
            onClick={() => setOpenSelectItems(!openSelectItems)}
          >
            {selectedGroups.length === 0 ? (
              <P id='unselectable'>Select team(s)</P>
            ) : (
              <P id='selectable'>
                {selectedGroups.map((group, index) => {
                  if (index === 0) {
                    return `${group.group_name}`;
                  }
                  return `, ${group.group_name}`;
                })}
              </P>
            )}
          </DropdownHeaderWrapper>
          {openSelectItems ? (
            <StyledChevronUp size={24} color={grey.z900} />
          ) : (
            <StyledChevronDown size={24} color={grey.z900} />
          )}
          {openSelectItems && (
            <DropdownOptions>
              <DropdownOptions.Groups>
                {groups.map(group => (
                  <CheckboxWrapper
                    key={group.group_id}
                    onClick={() => selectGroup(group)}
                  >
                    {selectedGroups.includes(group) ? (
                      <CheckedBox>
                        <Check size={15} color={white} />
                      </CheckedBox>
                    ) : (
                      <UncheckedBox />
                    )}
                    <P style={{ fontSize: '13px' }}>{group.group_name}</P>
                  </CheckboxWrapper>
                ))}
              </DropdownOptions.Groups>
            </DropdownOptions>
          )}
        </CustomDropdown>
      </SelectItemsContainer>
    );
  };

  const officeSelectItems = () => {
    return (
      <SelectItemsContainer handleClickOutside={handleOpenSelectItemsClose}>
        <CustomDropdown
          open={openSelectItems}
          style={{ pointerEvents: 'all' }}
          dark
        >
          <DropdownHeaderWrapper
            onClick={() => setOpenSelectItems(!openSelectItems)}
          >
            {selectedOffices.length === 0 ? (
              <P id='unselectable'>Select GST(s)</P>
            ) : (
              <P id='selectable'>
                {selectedOffices.map((office, index) => {
                  if (index === 0) {
                    return `${office.gst_number}`;
                  }
                  return `, ${office.gst_number}`;
                })}
              </P>
            )}
          </DropdownHeaderWrapper>
          {openSelectItems ? (
            <StyledChevronUp size={24} color={grey.z900} />
          ) : (
            <StyledChevronDown size={24} color={grey.z900} />
          )}
          {openSelectItems && (
            <DropdownOptions>
              {mappedOffices &&
                mappedOffices.map(office => (
                  <CheckboxWrapper
                    key={office.office_id}
                    onClick={() => selectOffice(office)}
                  >
                    {selectedOffices.includes(office) ? (
                      <CheckedBox>
                        <Check size={15} color={white} />
                      </CheckedBox>
                    ) : (
                      <UncheckedBox />
                    )}
                    <P style={{ fontSize: '13px' }}>{office.gst_number}</P>
                  </CheckboxWrapper>
                ))}
            </DropdownOptions>
          )}
        </CustomDropdown>
      </SelectItemsContainer>
    );
  };

  const renderModalFields = () => {
    return (
      <ReportFormWrapper>
        <Layout gap={25}>
          <Layout.Item colD={12} colT={12} colM={12}>
            <DropdownWrapper>
              <Dropdown
                value={selectedReportType.value}
                onSelect={handleReportTypeSelect}
                width='460px'
              >
                {reportTypeMenuItems()}
              </Dropdown>
            </DropdownWrapper>
          </Layout.Item>
          {selectDateRange()}
          {selectedReportType.key ===
            reportTypeEnum.REPORT_TYPE_GROUP_CONSUMPTION && groupsSelectItems()}
          {selectedReportType.key ===
            reportTypeEnum.REPORT_TYPE_GST_BASED_CONSUMPTION &&
            officeSelectItems()}
        </Layout>
      </ReportFormWrapper>
    );
  };
  const renderPollingPage = () => {
    return (
      <ReportResponseStateWrapper>
        <PollingStateWrapper>
          {(reportState === reportStatusEnum.REPORT_STATUS_UNSPECIFIED ||
            reportState === reportStatusEnum.REPORT_STATUS_INITIATED ||
            reportState === reportStatusEnum.REPORT_STATUS_PROCESSING) && (
            <ReponseHeader>
              <PollingModalsSpinnerHolder>
                <SpinnerWrapper>
                  <Spinner color={red.z_red} size='large' />
                </SpinnerWrapper>
              </PollingModalsSpinnerHolder>
            </ReponseHeader>
          )}
          {reportState === reportStatusEnum.REPORT_STATUS_GENERATED && (
            <ReponseHeader>
              <AlignItemsWrapper>
                <ContentsWrapper>
                  <JustifyContentWrapper>
                    <CheckCircleFill
                      color={green.z500}
                      size='10rem'
                      style={{ padding: '0px 30px 30px 30px' }}
                    />
                  </JustifyContentWrapper>
                  <JustifyContentWrapper>
                    <H4>
                      {iscurrentMonthConsumption ? 'Statement' : 'Report'}
                      {' '}
                      generated successfully
                    </H4>
                  </JustifyContentWrapper>
                  <Layout gap={30} style={{ marginTop: '4rem' }}>
                    <Layout.Item colD={6} colT={6} colM={6}>
                      <DownloadButtonWrapper>
                        <Button
                          style={ReportModalBtnStyle}
                          onClick={closeModal}
                        >
                          {' '}
                          Close
                          {' '}
                        </Button>
                      </DownloadButtonWrapper>
                    </Layout.Item>
                    <Layout.Item colD={6} colT={6} colM={6}>
                      <DownloadButtonWrapper
                        href={filePath}
                        target='_blank'
                        rel='noreferrer'
                      >
                        <Button style={ReportModalBtnStyleRed}>
                          {' '}
                          Download
                          {' '}
                        </Button>
                      </DownloadButtonWrapper>
                    </Layout.Item>
                  </Layout>
                </ContentsWrapper>
              </AlignItemsWrapper>
            </ReponseHeader>
          )}
          {reportState === reportStatusEnum.REPORT_STATUS_FAILED && (
            <ReponseHeader>
              <AlignItemsWrapper>
                <ContentsWrapper>
                  <JustifyContentWrapper>
                    <CheckCircleFill
                      color={red.z500}
                      size='10rem'
                      style={{ padding: '0px 30px 30px 30px' }}
                    />
                  </JustifyContentWrapper>
                  <JustifyContentWrapper>
                    <H4>
                      {iscurrentMonthConsumption ? 'Statement' : 'Report'}
                      {' '}
                      generation failed
                    </H4>
                  </JustifyContentWrapper>
                  <JustifyContentWrapper>
                    <P>
                      This is taking longer than usual, please try again later.
                    </P>
                  </JustifyContentWrapper>
                  <SubmitBtnWrapper>
                    <Button style={ReportModalBtnStyle} onClick={closeModal}>
                      Okay
                    </Button>
                  </SubmitBtnWrapper>
                </ContentsWrapper>
              </AlignItemsWrapper>
            </ReponseHeader>
          )}
          {reportState === reportStatusEnum.REPORT_STATUS_DELAYED && (
            <ReponseHeader>
              <AlignItemsWrapper>
                <ContentsWrapper>
                  <JustifyContentWrapper>
                    <CheckCircleFill
                      color={yellow.z500}
                      size='10rem'
                      style={{ padding: '0px 30px 30px 30px' }}
                    />
                  </JustifyContentWrapper>
                  <JustifyContentWrapper>
                    <H4>
                      {iscurrentMonthConsumption ? 'Statement' : 'Report'}
                      {' '}
                      generation in progress
                    </H4>
                  </JustifyContentWrapper>
                  <JustifyContentWrapper>
                    <P>
                      This is taking longer than usual. Report, once generated,
                      can be downloaded from this section.
                    </P>
                  </JustifyContentWrapper>
                  <SubmitBtnWrapper>
                    <Button style={ReportModalBtnStyle} onClick={closeModal}>
                      Okay
                    </Button>
                  </SubmitBtnWrapper>
                </ContentsWrapper>
              </AlignItemsWrapper>
            </ReponseHeader>
          )}
          {reportState === reportStatusEnum.REPORT_STATUS_SYSTEM_FAILED && (
            <ReponseHeader>
              <AlignItemsWrapper>
                <ContentsWrapper>
                  <JustifyContentWrapper>
                    <CheckCircleFill
                      color={yellow.z500}
                      size='10rem'
                      style={{ padding: '0px 30px 30px 30px' }}
                    />
                  </JustifyContentWrapper>
                  <JustifyContentWrapper>
                    <H4>
                      {iscurrentMonthConsumption ? 'Statement' : 'Report'}
                      {' '}
                      generation is pending
                    </H4>
                  </JustifyContentWrapper>
                  <JustifyContentWrapper>
                    <P>
                      We cannot process your request right now. 
                      {' '}
                      <br />
                      {' '}
                      Please
                      try again later.
                    </P>
                  </JustifyContentWrapper>
                  <SubmitBtnWrapper>
                    <Button style={ReportModalBtnStyle} onClick={closeModal}>
                      Okay
                    </Button>
                  </SubmitBtnWrapper>
                </ContentsWrapper>
              </AlignItemsWrapper>
            </ReponseHeader>
          )}
        </PollingStateWrapper>

        {iscurrentMonthConsumption &&
          (reportState === reportStatusEnum.REPORT_STATUS_GENERATED ||
            reportState === reportStatusEnum.REPORT_STATUS_DELAYED) && (
            <ReportModalFooter>
              <H4>
                This statement can also be downloaded from the Reports section
              </H4>
            </ReportModalFooter>
          )}
      </ReportResponseStateWrapper>
    );
  };
  return (
    <Modal
      title={title}
      visible={showModal}
      onClose={closeModal}
      isCentered
      showCloseIcon={
        !(
          iscurrentMonthConsumption &&
          reportState === reportStatusEnum.REPORT_STATUS_GENERATED
        )
      }
      overlayClickClose={
        !(
          iscurrentMonthConsumption &&
          reportState === reportStatusEnum.REPORT_STATUS_GENERATED
        )
      }
    >
      {initiateGeneration || isReportInitiated ? (
        renderPollingPage()
      ) : (
        <>
          {' '}
          {renderModalFields()}
          {' '}
          <CreateButtonWrapper>
            <Button
              disabled={continueDisabled}
              onClick={handleGenerateReport}
              icon={<SingleLineArrow />}
              iconAlign='right'
              loading={pollingStarted}
            >
              Continue
            </Button>
          </CreateButtonWrapper>
          {' '}
        </>
      )}
    </Modal>
  );
};

CreateReportModal.propTypes = {
  title: PropTypes.string,
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  reportID: PropTypes.string,
  groupsData: PropTypes.objectOf(PropTypes.any),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  generateReport: PropTypes.func,
  initiatingReport: PropTypes.bool,
  initiatedReport: PropTypes.bool,
  iscurrentMonthConsumption: PropTypes.bool,
  isBulkOrderInvoicesEnabled: PropTypes.bool,
  mappedOffices: PropTypes.objectOf(PropTypes.any),
  invoiceData: PropTypes.objectOf(PropTypes.any),
  invoiceStartDate: PropTypes.string,
};

CreateReportModal.defaultProps = {
  title: '',
  showModal: false,
  closeModal: _noop,
  reportID: '',
  groupsData: {},
  selectedWorkspace: {},
  generateReport: _noop,
  initiatingReport: true,
  initiatedReport: true,
  iscurrentMonthConsumption: false,
  isBulkOrderInvoicesEnabled: false,
  mappedOffices: {},
  invoiceData: {},
  invoiceStartDate: '',
};

export default CreateReportModal;
